@if (!isMobile) {
    <div class="system-recommendation-container" rtlDiv>
        <div class="title">{{ 'TITLES.SYSTEM_RECOMMENDATION' | translate }}</div>        
        <div class="chart-actions" [hidden]="spinnerActive">
            <div class="chart-navigation">
                <button class="nav-btn" (click)="prevPage()" [disabled]="currentPage === 0">&#10094;</button>              
                <div class="nav-title">
                  {{ navigationLabel }}
                </div>              
                <button class="nav-btn" (click)="nextPage()" [disabled]="(currentPage + 1) * pageSize >= fullChartData.labels.length">&#10095;</button>
            </div>
            <div>
                <span [class.activeAction]="selectedRange == 'day'" class="chart-action" (click)="changeRange('day')">{{ 'COLLECTION_REPORT.DAILY' | translate }}</span>
                <span [class.activeAction]="selectedRange == 'week'" class="chart-action" (click)="changeRange('week')">{{ 'COLLECTION_REPORT.WEEK' | translate }}</span>
                <span [class.activeAction]="selectedRange == 'month'" class="chart-action" (click)="changeRange('month')">{{ 'COLLECTION_REPORT.MONTH' | translate }}</span>
            </div>
        </div>
    </div>
    <div class='spinner-container' [hidden]="!spinnerActive">
        <div class="spinner"></div>
    </div>
    <div class="graph-container" [hidden]="spinnerActive">
        <div class="graph-data">
            <canvas id="systemRecommendationData"></canvas>
        </div>
    </div>
}

@if (isMobile) {
}